import { Component, inject, signal, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { IconService } from './core/services/icon.service';
import { IdleService } from './core/services/idle.service';
import { SeoService } from './core/services/seo.service';
import { organizationSchema } from './core/constants/structured-data.constants';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  protected readonly title = signal('ComplyDesk');

  private iconService = inject(IconService);
  private idleService = inject(IdleService);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private seoService = inject(SeoService);
  private platformId = inject(PLATFORM_ID);

  constructor() {
    this.registerAllIcons();
  }

  ngOnInit(): void {
    // fromEvent(document, ...) inside IdleService throws under SSR/prerendering,
    // where there's no real browser document to attach listeners to.
    if (isPlatformBrowser(this.platformId)) {
      this.idleService.startMonitoring();
    }
    this.setPageMetadata();
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.setPageMetadata();
    });
  }

  private setPageMetadata(): void {
    let currentRoute = this.activatedRoute;
    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }

    const data = currentRoute.snapshot.data as {
      title?: string;
      description?: string;
      keywords?: string;
      robots?: string;
      structuredData?: object | object[];
    };

    const url = currentRoute.snapshot.url.map((segment) => segment.path).join('/') || '/';

    this.seoService.updateTitle(data?.title);
    this.seoService.updateMeta({
      description: data?.description,
      keywords: data?.keywords,
      robots: data?.robots,
      url,
    });
    this.seoService.updateStructuredData(data?.structuredData ?? organizationSchema);
  }

  private registerAllIcons() {
    this.iconService.registerIcons();
  }
}
